import React from 'react';
import { Image, TouchableOpacity } from 'react-native';
import { LocStr } from '../../../utils/Utils';
import { contact_list_design } from '../../../utils/DictionaryManagementUtils';
import { img_collapse, img_expand } from '../../../utils/ImagesManagementUtils';
import Title from '../Text/Title';

//= ========================================================================

const ContactListHeadline = ({ language, expandEditText, onValueChanged }) => {
  const myStyles = {
    container: { flexDirection: 'row', alignItems: 'center', marginBottom: 5 },
    image: {
      width: 16,
      height: 16,
      marginLeft: 2 + 4,
      marginTop: 4,
    },
  };

  return (
    <TouchableOpacity
      style={myStyles.container}
      activeOpacity={1}
      onPress={() => {
        onValueChanged(!expandEditText);
      }}
    >
      <Title marginBottom={0} isBold>{LocStr(contact_list_design, language)}</Title>
      <Image
        fadeDuration={0}
        style={myStyles.image}
        source={expandEditText ? img_collapse : img_expand}
      />
    </TouchableOpacity>
  );
};
export default ContactListHeadline;
